'use client';

import Link from 'next/link';

import { SOCIAL_CONFIG } from '../constants';
import { ContactsCommonProps } from './types';

import IconMax from '@/assets/icons/iconMax.svg';
import IconTelegramSquare from '@/assets/icons/iconTelegramSquare.svg';
import IconWhatsAppSquare from '@/assets/icons/iconWhatsAppSquare.svg';
import { getDomainKey, isRuDomain } from '@/shared/utils/getDomainInfo';

export const IconsBlock = ({ clientHost }: ContactsCommonProps) => {
  if (isRuDomain(clientHost)) {
    return (
      <Link href={SOCIAL_CONFIG.ru.max} target="_blank" aria-label="max">
        <IconMax />
      </Link>
    );
  }

  const social = SOCIAL_CONFIG[getDomainKey(clientHost)];

  return social ? (
    <>
      <Link href={social.telegram} aria-label="telegram" target="_blank">
        <IconTelegramSquare />
      </Link>
      <Link href={social.whatsapp} aria-label="whatsapp" target="_blank">
        <IconWhatsAppSquare />
      </Link>
    </>
  ) : null;
};
